import { Outlet } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';

import { Header } from '../components/Header';

import { Container, ContainerInner } from './Layout.styles';

export function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Container>
          <Header />
          <ContainerInner>
            <Outlet />
          </ContainerInner>
        </Container>
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}
